import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const baseClasses = `
    relative overflow-hidden
    bg-[#F59E0B] text-white font-bold text-lg md:text-xl
    py-4 px-8 rounded-lg shadow-lg shadow-amber-500/20
    transition-colors duration-200 hover:bg-[#D97706]
    flex items-center justify-center gap-2
    ${fullWidth ? 'w-full' : 'w-auto'}
    ${className}
  `;
  const motionProps = {
    whileHover: {
      scale: 1.02,
      boxShadow: '0 10px 25px -5px rgba(245, 158, 11, 0.4)'
    },
    whileTap: {
      scale: 0.98
    }
  };
  if (href) {
    return <motion.a {...motionProps} href={href} target="_blank" rel="noopener noreferrer" className={baseClasses} data-id="element-171">
        <span data-id="element-172">{children}</span>
        <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-173" />
      </motion.a>;
  }
  return <motion.button {...motionProps} onClick={onClick} className={baseClasses} data-id="element-174">
      <span data-id="element-175">{children}</span>
      <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-176" />
    </motion.button>;
}